import { render, staticRenderFns } from "./CampaignInfoList.vue?vue&type=template&id=ff2bf8f6"
import script from "./CampaignInfoList.vue?vue&type=script&lang=js"
export * from "./CampaignInfoList.vue?vue&type=script&lang=js"
import style0 from "./CampaignInfoList.vue?vue&type=style&index=0&id=ff2bf8f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports